import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

import Error404Page from '../Error404Page.js';

//import components
import BackButton from './BackButton.js';

const ObjectNotFound = ({ clang }) => {
    return (
        <div className="item__not-found">
            <BackButton />
            <Error404Page />
        </div>
    );
};

ObjectNotFound.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ObjectNotFound);



// WEBPACK FOOTER //
// ./src/components/items/ObjectNotFound.js